import {
    IStatePointResult, IStatePoint,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import BaseStatePoint from '@src/slide/application/service/slide-render-state/state-point/base-state-point';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export default class VisibleSlideRenderStatePoint extends BaseStatePoint implements IStatePoint {
    public emitPointComplete(params: IStatePointResult): boolean {
        const isFirstTime = super.emitPointComplete(params);
        if (isFirstTime) {
            this.completeResolve(params);
            eventBus.emit(EventKeys.VISIBLE_PAGE_DISPLAY);
            window.log?.info('[tti-notifyVisibleSlideRenderCompleted]', params.time, params.entry);
        }
        return isFirstTime;
    }
}
